import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";

export const EjercicioSelect = ({
  value,
  onChange,
  start_year = 2024,
  extra_year = 0,
}) => {
  const [years, setYears] = useState([]);
  useEffect(() => {
    const year = Number(new Date().getFullYear()) + Number(extra_year);
    var start = start_year;
    var arrayyears = [];
    while (start <= year) {
      arrayyears = [...arrayyears, start];
      start = start + 1;
    }
    setYears(arrayyears);
  }, []);
  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label-ejercicio">Ejercicio</InputLabel>
      <Select
        size="small"
        labelId="demo-simple-select-label-ejercicio"
        id="demo-simple-select-ejercicio"
        value={value}
        label="Ejercicio"
        onChange={(event) => onChange(event.target.value)}
      >
        {years.map((element) => (
          <MenuItem value={element}>{element}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
